// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2rZy1","header":"PatientBlock_header__1O8A5","label":"PatientBlock_label__2xo0i","option":"PatientBlock_option__2MJlL"};